import { render, staticRenderFns } from "./TrialPlan.vue?vue&type=template&id=081f822c&"
import script from "./TrialPlan.vue?vue&type=script&lang=js&"
export * from "./TrialPlan.vue?vue&type=script&lang=js&"
import style0 from "./TrialPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports